import React, {FC, Fragment, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {actions} from '../../store';
import {useSelector} from 'react-redux';
import selectIsProductExpanded from '../../store/selectors/select-is-product-expanded';
import ProductVariant from './product-variant';
import {useGetVariantsInStockQuery} from '../../store/endpoints/get-variants-in-stock';
import {ObjectId} from 'types/object-id';
import clsx from 'clsx';
import {columnClassNames} from '../../constants/grid-classnames';
import {useParams} from 'react-router';
import NaturalNumber from 'components/natural-numbers/natural-numbers';
import Currency from 'components/currency/currency';

interface Props {
  collection: {
    id: ObjectId;
    name: string;
    stock: number[];
  };
  product: {
    id: ObjectId;
    name: string;
    stock: number[];
  };
  family: {
    id: ObjectId;
    name: string;
  };
}

const Product: FC<Props> = props => {
  const {product, family, collection} = props;
  const {type} = useParams();

  const dispatch = useDispatch();

  const isExpanded = useSelector(selectIsProductExpanded(product.id));

  const handleExpand = () => {
    dispatch(actions.expandProduct(product));
  };

  const {data, isFetching} = useGetVariantsInStockQuery(
    {
      id: family.id,
      productId: product.id,
      collectionId: collection.id,
      type: type || '',
    },
    {skip: !isExpanded}
  );

  const variants = useMemo(() => {
    if (data) {
      return data.data;
    }
    return [];
  }, [data]);
  return (
    <Fragment>
      {/* parentRow */}
      <tr
        onClick={handleExpand}
        className={clsx({
          'highlighter-level--3': true,
          'cursor-state--idle': !isFetching,
          'cursor-state--loading': isFetching,
        })}
      >
        <td className="p-2">{`${product.name}`}</td>
        {product.stock.map((x, index) => {
          return (
            <td
              key={`product-${x}--${index}`}
              className={clsx({'p-2': true, [columnClassNames[index]]: true})}
            >
              {index === 10 || index === 11 || type === 'quantity' ? (
                <NaturalNumber value={x} />
              ) : (
                <Currency value={x} />
              )}
            </td>
          );
        })}
      </tr>
      {/* children */}
      {!isFetching &&
        isExpanded &&
        variants.map(v => (
          <ProductVariant key={v.id} productId={product.id} row={v} />
        ))}
    </Fragment>
  );
};

export default Product;
